import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils';
import { AlgorithmSourceFormDataSchema } from './AlgorithmSourceFormDataSchema';
import {
  AlgorithmSourceFormDataType,
  AlgorithmSourceQueryDtoType,
} from './types';

const AlgorithmSourcesConfidentialityRuleSourceFormDataSchema = z.object({
  dimension: z.string(),
  index: z.number(),
});

export const AlgorithmSourcesConfidentialityRuleFormDataSchema =
  z.discriminatedUnion('useDimension', [
    z.object({
      useDimension: z.literal(true),
      source: AlgorithmSourcesConfidentialityRuleSourceFormDataSchema,
    }),
    z.object({
      useDimension: z.literal(false),
      source: z.preprocess(() => null, z.null().optional()),
    }),
  ]);

export const AlgorithmSourcesFormDataSchema = z.object({
  algorithmId: z.number(),
  sources: transformNullish<
    AlgorithmSourceFormDataType[],
    AlgorithmSourceQueryDtoType[]
  >(AlgorithmSourceFormDataSchema.array(), []),
  confidentialityRule: transformNullish<
    z.output<typeof AlgorithmSourcesConfidentialityRuleFormDataSchema>,
    z.input<typeof AlgorithmSourcesConfidentialityRuleFormDataSchema>
  >(AlgorithmSourcesConfidentialityRuleFormDataSchema, { useDimension: false }),
});
